<mat-card class="card-item">
  <div class="card-item__thumb">
    <div class="card-item__thumb-img" [ngClass]="{ blur: !data.id }">
      @if (!data.id && !!data.thumbnailUri) {
        <img
          class="blur"
          [src]="getLinkImage() | secure | async"
          [alt]="getLinkImage() | secure | async"
          [hidden]="!isImageLoaded"
          matTooltipPosition="above"
          (load)="checkImageLoaded()"
          />
      }
      @if (!!data.id && !!data.thumbnailUri) {
        <img
          [ngClass]="{ blur: !data.id }"
          class="cursor-pointer"
          [src]="getLinkImage() | secure | async"
          [alt]="getLinkImage() | secure | async"
          [hidden]="!isImageLoaded"
          matTooltipPosition="above"
          (load)="checkImageLoaded()"
          (click)="open()"
          />
      }
      @if (!isImageLoaded || !data.thumbnailUri) {
        <div
          class="card-item__no-img"
          >
          <img
            [ngClass]="!!data.id ? 'cursor-pointer' : ''"
            [src]="'assets/image-placeholder.jpg'"
            alt="Image Error"
            matTooltipPosition="above"
            (click)="!!data.id ? open() : ''"
            />
        </div>
      }
    </div>
  </div>
  <mat-card-content>
    <div class="content-item">
      <div>
        <div class="card-item__label" [title]="data.label">
          {{ data.label }}
        </div>
      </div>
      @if (data.enhancementFlag) {
        <i class="material-icons sparkle"
          >auto_awesome</i
          >
        }
        <span class="spacer"></span>
        @if (isShootAsset) {
          <div style="display: flex">
            @if (data.id && data.internalReviewState == null) {
              <div>
                <button
                  color="error"
                  mat-icon-button
                  class="action_button"
                  (click)="onReview(EStateAsset.REJECTED)"
                  >
                  <mat-icon>cancel</mat-icon>
                </button>
                <button
                  color="success"
                  mat-icon-button
                  class="action_button"
                  (click)="onReview(EStateAsset.APPROVED)"
                  >
                  <mat-icon>check_circle</mat-icon>
                </button>
              </div>
            }
            @if (data.internalReviewState != null) {
              <div
                (click)="onReview(null)"
                class="card-item__status-text"
          [ngClass]="{
            approved: data.internalReviewState === EStateAsset.APPROVED,
            'in-review': data.internalReviewState === EStateAsset.IN_REVIEW,
            rejected: data.internalReviewState === EStateAsset.REJECTED
          }"
                >
                {{ statusMapping[data.internalReviewState] }}
              </div>
            }
          </div>
        }
        @if (!isShootAsset) {
          <div style="display: flex">
            @if (data.id && data.clientReviewState == null) {
              <div>
                <button
                  color="error"
                  mat-icon-button
                  class="action_button"
                  (click)="onReview(EStateAsset.REJECTED)"
                  >
                  <mat-icon>cancel</mat-icon>
                </button>
                <button
                  color="success"
                  mat-icon-button
                  class="action_button"
                  (click)="onReview(EStateAsset.APPROVED)"
                  >
                  <mat-icon>check_circle</mat-icon>
                </button>
              </div>
            }
            @if (data.clientReviewState != null) {
              <div
                (click)="onReview(null)"
                class="card-item__status-text"
          [ngClass]="{
            approved: data.clientReviewState === EStateAsset.APPROVED,
            'in-review': data.clientReviewState === EStateAsset.IN_REVIEW,
            rejected: data.clientReviewState === EStateAsset.REJECTED
          }"
                >
                {{ statusMapping[data.clientReviewState] }}
              </div>
            }
          </div>
        }
        @if (
          (!!data.id || (data.variantTouchAssetId && data.productTouchId)) &&
          authService.hasPermission(Permission.PostAssetsFull)
          ) {
          <button
            [matMenuTriggerFor]="actionsMenu"
            mat-icon-button
            matTooltip="More"
            color="primary"
            class="action_button"
            style="margin: 0px !important"
            >
            <mat-icon>more_vert</mat-icon>
          </button>
        }
        <mat-menu #actionsMenu="matMenu">
          <button
            mat-menu-item
            (click)="getLinkDownload()"
            [disabled]="!data.thumbnailUri"
            >
            <mat-icon>download</mat-icon>
            <span>Download</span>
          </button>
          <button
            mat-menu-item
            (click)="onEdit()"
            [disabled]="!data.thumbnailUri"
            >
            <mat-icon>rate_review</mat-icon>
            <span>Review</span>
          </button>
        </mat-menu>
        @if (!!data.id && !authService.hasPermission(Permission.PostAssetsFull)) {
          <button
            mat-icon-button
            [disabled]="!data.thumbnailUri"
            (click)="onEdit()"
            matTooltip="Asset review"
            class="action_button"
            >
            <mat-icon>rate_review</mat-icon>
          </button>
        }
        @if (!data.id) {
          <div class="card-item__description">Pending</div>
        }
      </div>
    </mat-card-content>
  </mat-card>
